"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = (0, _react.createContext)(null);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-pdf/dist/OutlineContext.js
// module id = 32
// module chunks = 1 2 3 4 5 6 7 8